module.exports = __webpack_public_path__ + "img/check_signature_icon.118bb38b.svg";